import { render } from "./middleColumnGrid.vue?vue&type=template&id=362db4ae&scoped=true"
const script = {}

import "./middleColumnGrid.vue?vue&type=style&index=0&id=362db4ae&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362db4ae"]])

export default __exports__